import { StringId } from '../localizer/stringId'

export const strings = {
  [StringId.DV_TW_title_starring]: 'Starring',
  [StringId.DV_TW_title_actors]: 'Supporting actors',
  [StringId.DV_TW_title_producers]: 'Producers',
  [StringId.DV_TW_title_genres]: 'Genres',
  [StringId.DV_TW_title_subtitles]: 'Subtitles',
  [StringId.DV_TW_title_languages]: 'Audio Languages',
  [StringId.DV_TW_title_director]: 'Directors',
  [StringId.DV_TW_title_studio]: 'Studio',
  [StringId.DV_TW_title_network]: 'Network',
  [StringId.DV_TW_title_seasonyear]: 'Season year',
  [StringId.DV_TW_title_amr]: 'Amazon Maturity Rating',
  [StringId.DV_DP_learn_more]: 'Learn more',
  [StringId.DV_DP_ARIA_learn_more_amr]: 'Learn more about Amazon Maturity Rating',
  [StringId.DV_comma_separator]: ', ',
  [StringId.DV_TW_title_purchaserights]: 'Purchase rights',
  [StringId.DV_TW_title_devices]: 'Devices',
  [StringId.DV_TW_data_available_to_watch_devices]: 'Available to watch on {link|supportedDevicesLink}supported devices{end}.',
  [StringId.DV_TW_data_purchaserights_streaming]: 'Stream instantly',
  [StringId.DV_TW_Detail_text]: 'Details',
  [StringId.DV_TW_title_format]: 'Format',
  [StringId.DV_TW_data_format_streaming]:
    'Prime Video (streaming online video)',
  [StringId.DV_TW_title_mpaarating]: 'MPAA rating',
  [StringId.DV_TW_title_bbfcrating]: 'BBFC rating',
  [StringId.DV_TW_title_fskrating]: 'FSK rating',
  [StringId.DV_TW_title_eirinrating]: 'Rating',
  [StringId.DV_DP_more_details]: 'More details',
  [StringId.DV_DP_more_items]: 'more…',
  [StringId.DV_brand_av]: 'Prime Video',
  [StringId.DV_WEB_DP_popover_purchase_rights]: `{paragraph}When you buy a video, your viewing rights don’t expire, except as detailed in the {link|touLink}Terms of Use{end}. You can Watch
                        Now or Download the video to a {link|compatibleDeviceLink}compatible device{end}, except for Pay-Per-View videos.
                        Pay-Per-View videos will become available to watch once the event starts, will be available for playback for 24 hours
                        following the event, and are not available for Download.{end}
                        {paragraph}If you choose Watch Now, the video will instantly stream to your computer and you may later stream it on another
                        compatible device. If downloading is available, you can {link|learnDownloading}download the video{end} to two locations. This
                        enables you to watch the video without an Internet connection.{end}
                        {paragraph}Some new release movies become unavailable for downloading for a limited time due to licensing restrictions. If
                        applicable, we will notify you about this before processing your order.{end}
                        {paragraph}Additional restrictions may apply. For more information, go to the {link|touLink}Terms of Use{end}.{end}`
}
